import { ConciergeService, MetaService, EventBaseService } from 'ac-ui-core-local';
import { EventType } from 'ac-ui-core-local/meta/meta.types';
import { Injectable } from '@angular/core';

export class FilterOption {
	name: string;
	value: any;
	selected?: boolean;
}

@Injectable()
export class FilterMetaService {
	private eventTypes: Promise<EventType[]>;
	private eventStates: Promise<EventType[]>;

	constructor(private _ms: MetaService, private _cs: ConciergeService, private _ebs: EventBaseService) {
		this.eventTypes = this._ms.getEventTypes();
		this.eventStates = this._ms.getEventTypes();
	}

	public getEventOccasions(): Promise<FilterOption[]> {
		return this._ms.getEventOccasions()
			.then(x => x.map(y => ({ name: y.name, value: y.eventOccasionId })));
	}

	public getEventVerticals(): Promise<FilterOption[]> {
		return this._ms.getEventVerticals()
			.then(x => x.map(y => ({ name: y.name, value: y.eventVerticalId })));
	}

	public async getEventTypes(eventVerticalIds?: number[] | number): Promise<FilterOption[]> {
		const eventTypes = await this.eventTypes;

		return eventTypes
			.filter(x => eventVerticalIds instanceof Array ? (eventVerticalIds.length === 0 || eventVerticalIds.includes(x.eventVerticalId))
				: (!eventVerticalIds || eventVerticalIds === x.eventVerticalId)
			)
			.map(x => ({ name: x.name, value: x.eventTypeId }));
	}

	public async getEventStates(eventVerticalIds?: number[] | number): Promise<FilterOption[]> {
		const eventStates = await this.eventStates;
		const states: string[] = [];
		const stateOptions: FilterOption[] = [];

		eventStates
			.filter(
				x => eventVerticalIds instanceof Array ?
					((eventVerticalIds.length === 0 || eventVerticalIds.includes(x.eventVerticalId)) && x.location && x.location.state)
					: ((!eventVerticalIds || eventVerticalIds === x.eventVerticalId) && x.location && x.location.state)
			)
			.forEach(
				(x) => {
					const s = x.location.state;
					if (s && states.indexOf(s) < 0) {
						states.push(s);
						stateOptions.push({ name: s, value: s });
					}
				}
			);

		return stateOptions;
	}

	public getConcierges(): Promise<FilterOption[]> {
		return this._cs.getConcierges()
			.then(x => x.map(y => ({ name: y.name, value: y.conciergeId })));
	}

	public getEventBases(): Promise<FilterOption[]> {
		return this._ebs.getEventBases()
			.then(x => x.results.map(y => ({ name: y.name, value: y.eventBaseId })));
	}

}
